import { render } from "./CheckForm.vue?vue&type=template&id=0a9ac8d0"
import script from "./CheckForm.vue?vue&type=script&lang=js"
export * from "./CheckForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__